var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-message-footer mt-2" }, [
    !_vm.isStreaming && _vm.messageId
      ? _c(
          "div",
          { staticClass: "chat-message-footer__actions d-flex align-center" },
          [
            _c("FeedbackButtons", {
              attrs: {
                "message-id": _vm.messageId,
                "current-feedback": _vm.currentFeedback,
                "current-comentario": _vm.currentComentario
              },
              on: { feedback: _vm.onFeedback }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }